import {useMemo, useState} from "react";

type UseDynamicListFieldOptions = {
	initialItems?: Record<number, string>;
};

type UseDynamicListField = [
	items: Record<number, string>,
	{
		setItems: (items: Record<number, string>) => void;
		setItem: (key: number, value: string) => void;
		resetItems: () => void;
	},
];

const useDynamicListField: (
	options?: UseDynamicListFieldOptions
) => UseDynamicListField = ({initialItems = {}} = {}) => {
	const [items, setItems] = useState<Record<number, string>>(initialItems);

	const handlers = useMemo(
		() => ({
			setItems: (newItems: Record<number, string>) => {
				setItems(newItems);
			},
			setItem: (key: number, value: string) => {
				setItems((currentItems) => {
					const newItems = {...currentItems};
					newItems[key] = value;
					if (!value) {
						delete newItems[key];
					}
					return newItems;
				});
			},
			resetItems: () => {
				setItems(initialItems);
			},
		}),
		[initialItems]
	);

	return [items, handlers];
};

export default useDynamicListField;
